/* eslint-disable complexity */

import { useEffect, useRef, useState } from "react";
import { generateMongoFilter } from "../utils/helpers/mongo-rtd-utils/mongo-rtd-filter";
import { MONGO_DB_CONFIG } from "../utils/helpers/mongo-rtd-utils/mongo-db-config";

const useMongoListener = ({
    credentialType = "B2C_SAME_SESSION",
    operationType = ["insert", "delete", "replace", "update"],
    conditionToConnect = false,
    shouldListeningStartFromMongo = false,
    getInitialData = true,
    ...filterQueryParams}) => {

    const [mongoData, setMongoData] = useState();

    const realmWebRef = useRef({});
    const mongoAppRef = useRef({});
    const collectionRef = useRef({});
    const stopListeningRef = useRef(false);

    const filterQuery = generateMongoFilter({filters: filterQueryParams});
    const  {
        MONGO_RTD_DB_NAME,
        MONGO_RTD_COLLECTION_NAME
    } = MONGO_DB_CONFIG[credentialType];

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const signInAndFetchDetails = async () => {
        const credentials = realmWebRef.current.Credentials.apiKey(process.env.MONGO_RTD_AUTHENTICATION_API_KEY);

        const user = await mongoAppRef.current.logIn(credentials);
        const mongodb = user.mongoClient(process.env.MONGO_RTD_ATLAS_KEY);
        collectionRef.current = mongodb
            .db(MONGO_RTD_DB_NAME)
            .collection(MONGO_RTD_COLLECTION_NAME);

        if (getInitialData) {
            const initialDocument = await collectionRef.current.findOne(
                filterQuery,
                {
                    sort: { updatedAt: -1 }
                }
            );

            setMongoData(initialDocument);
        }
    };

    const addListener = async() => {
        const updatedFilterQuery = generateMongoFilter({filters: filterQueryParams, searchFullDocument: true });
        const changeStream = collectionRef.current.watch({
            filter: updatedFilterQuery
        });
        stopListeningRef.current = changeStream;
        for await (const change of changeStream) {
            if (operationType.includes(change.operationType)) setMongoData(change.fullDocument);
        }
    };

    const logoutUser = async() => {
        if (mongoAppRef && mongoAppRef.current && mongoAppRef.current.currentUser) {
            await mongoAppRef.current.currentUser.logOut();
            stopListeningRef.current.return();
        }
    };

    useEffect(() => {
        if (conditionToConnect && shouldListeningStartFromMongo) {
            import(/*web-realm-chunk*/"realm-web").then(module => {
                realmWebRef.current = module;
                mongoAppRef.current = new realmWebRef.current.App({ id: process.env.MONGO_RTD_APP_ID });
                signInAndFetchDetails().then(() => {
                    addListener();
                });
            }).catch(() => "");
            return () => logoutUser();
        }
        return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shouldListeningStartFromMongo, conditionToConnect]);

    return { mongoData };

};
export default useMongoListener;

